var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGenericCurrency = function SvgGenericCurrency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9 8.7c0 1.215 1.045 2.2 2.333 2.2h2.334C14.955 10.9 16 9.915 16 8.7c0-1.215-1.045-2.2-2.333-2.2h-2.334C10.045 6.5 9 5.515 9 4.3c0-1.215 1.045-2.2 2.333-2.2h2.334C14.955 2.1 16 3.085 16 4.3M12.5 1v11M10 14.188A4.64 4.64 0 0 0 6.906 13c-2.64 0-4.781 2.239-4.781 5s2.14 5 4.781 5A4.64 4.64 0 0 0 10 21.812m-9-2.636h5.625M1 16.825h5.625M22 23h-7s2.227-1.623 2.227-4.118c0-1.663-1.327-2.258-1.347-3.644.002-2.743 3.575-2.597 4.817-1.507M15 18.882h5.41"
  })));
};
export default SvgGenericCurrency;